import { KvCalendarComponent } from './../../../../modules/UIKit/components/kv-calendar/kv-calendar.component';
import { SelectItem } from 'primeng/components/common/api';
import { Campaign2Service } from 'app/services/campaign-2.0/campaign2.service';
import { Validators } from '@angular/forms';
import { FormBuilder } from '@angular/forms';
import { FormGroup } from '@angular/forms';
import { Component, OnInit, Output, ViewChild, EventEmitter, Input } from '@angular/core';
import * as moment from 'moment';

@Component({
  selector: 'app-campaign-action-duplicate-form',
  templateUrl: './campaign-action-duplicate-form.component.html',
  styleUrls: ['./campaign-action-duplicate-form.component.scss']
})
export class CampaignActionDuplicateFormComponent implements OnInit {
  form: FormGroup;
  campaignList: SelectItem[];
  campaignActionList: SelectItem[];
  startCampaignDate: Date;
  endCampaignDate: Date;
  actionTypeCode: string;
  productItemList: SelectItem[];
  productItemBarcodeList: SelectItem[];
  invalidSubmit = false;
  @ViewChild('emissionStartField') emissionStartField: KvCalendarComponent;
  @ViewChild('emissionEndField') emissionEndField: KvCalendarComponent;
  @ViewChild('fruitionStartField') fruitionStartField: KvCalendarComponent;
  @ViewChild('fruitionEndField') fruitionEndField: KvCalendarComponent;
  @Output() onDuplicateCampaignAction: EventEmitter<any> = new EventEmitter();
  @Input() campaignId: number;

  constructor(
    private fb: FormBuilder,
    private campaign2Service: Campaign2Service
  ) { }

  ngOnInit() {
    this.campaign2Service.getCampaign(this.campaignId).subscribe(res => {
      this.startCampaignDate = new Date(res[0].start_date);
      this.endCampaignDate = new Date(res[0].end_date);
    })
    this.form = this.fb.group({
      campaign: ['', Validators.required],
      campaignAction: ['', Validators.required],
      emissionStartDate: ['', Validators.required],
      emissionEndDate: ['', Validators.required],
      fruitionStartDate: ['', Validators.required],
      fruitionEndDate: ['', Validators.required],
      itemCode: ['', Validators.required],
      barCode: ['', Validators.required],
      duplicateActionName: ['', Validators.required]
    });
  }

  filterCampaign(event) {
    if(event) {
      const search = [
        {key: 'search_name',value: event.query},
        {key: 'flg_state',value: "0"}
      ];
      this.campaign2Service.list(null, null, search).subscribe(res => {
        if(res && res.data) {
          this.campaignList = res.data;
        }
      })
    }
  }

  filterCampaignAction(event) {
    if(event) {
      const search = [
        {key: 'search_name',value: event.query},
        {key: 'flg_state',value: "0"}
      ];
      const campaignId = this.form.get('campaign').value.id;
      this.campaign2Service.filterCampaignAction(campaignId, null, null, search).subscribe(res => {
        this.campaignActionList = [];
        if(res && res.data) {
          this.campaignActionList = res.data;
        }
      })
    }
  }

  filterByProductItem(event) {
    this.campaign2Service.getProductItemByHostCode(event.query).subscribe(res => {
      this.productItemList = [];
      if (res) {
        res.forEach(productItem => {
          this.productItemList.push({label: productItem.host_code + ' - ' + productItem.short_description, value: productItem.id})
        });
      }
    });
  }

  getProductItemBarcode(event) {
    this.productItemBarcodeList = [];
    this.campaign2Service.getProductItemBarcodeById(event.value).subscribe(res => {
      if (res) {
        res.forEach(barcode => {
          this.productItemBarcodeList.push({label: barcode.barcode, value: barcode.barcode})
        });
        this.form.get('barCode').setValue( res[0].barcode);
      }
    });
  }

  onCampaignSelection(campaign: any) {
    this.form.get('campaignAction').setValue('');
    this.emissionStartField.clearInputField();
    this.form.get('emissionStartDate').setValue('');
    this.emissionEndField.clearInputField();
    this.form.get('emissionEndDate').setValue('');
    this.fruitionStartField.clearInputField();
    this.form.get('fruitionStartDate').setValue('');
    this.fruitionEndField.clearInputField();
    this.form.get('fruitionEndDate').setValue('');
    this.form.get('itemCode').setValue('');
    this.form.get('barCode').setValue('');
    //this.startCampaignDate = new Date(campaign.start_date);
    //this.endCampaignDate = new Date(campaign.end_date);
  }

  onCampaignActionSelection(action: any) {
    this.actionTypeCode = action.action_type_code;
    this.form.get('itemCode').setValue('');
    this.form.get('barCode').setValue('');
    this.form.get('itemCode').setValidators([Validators.required]);
    this.form.get('barCode').setValidators([Validators.required]);

    //if (this.actionTypeCode !== 'MSG') {
    //  this.form.get('itemCode').setValidators([Validators.required]);
    //  this.form.get('barCode').setValidators([Validators.required]);
    //} else {
    //  this.form.get('itemCode').clearValidators();
    //  this.form.get('barCode').clearValidators();
    //}
    
    this.form.get('itemCode').updateValueAndValidity();
    this.form.get('barCode').updateValueAndValidity();
  }

  duplicateCampaignAction() {
    if(this.actionTypeCode == 'MSG') {
      this.form.get('fruitionStartDate').setValue(this.form.get('emissionStartDate').value)
      this.form.get('fruitionEndDate').setValue(this.form.get('emissionEndDate').value)
    }
    if (!this.form.valid) {
      this.invalidSubmit = true;
      return;
    }
    this.invalidSubmit = false;
    const data = {
      idCampaignFrom: this.form.get('campaign').value.id,
      idCampaignTo: this.campaignId,
      messageInstanceId: this.form.get('campaignAction').value.message_instance_id,
      campaignActionId: this.form.get('campaignAction').value.id,
      newActionname: this.form.get('duplicateActionName').value,
      start_date_emission: moment(this.form.get('emissionStartDate').value).format('YYYY-MM-DD'),
      end_date_emission: moment(this.form.get('emissionEndDate').value).format('YYYY-MM-DD'),
      start_date_fruition: moment(this.form.get('fruitionStartDate').value).format('YYYY-MM-DD'),
      end_date_fruition: moment(this.form.get('fruitionEndDate').value).format('YYYY-MM-DD'),
      codice_articolo: this.form.get('itemCode').value.value,
      barcode: this.form.get('barCode').value
    }
    this.onDuplicateCampaignAction.emit(data);
  }

}



// WEBPACK FOOTER //
// ./src/app/views/campaign-2.0/campaign-list2/campaign-action-duplicate-form/campaign-action-duplicate-form.component.ts